import React from 'react'
import Header from '../include/Header'
import Sidebar from '../include/Sidebar'
import { Link } from 'react-router-dom'

const ManageHoliday = () => {
    return (
        <div className="main-wrapper">
            <Header />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h3 className="page-title">Holiday</h3>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/admin/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item"><Link to='/admin/holiday-management'>Holiday Management</Link></li>
                                    <li className="breadcrumb-item active">Add Holiday</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="card p-3 basicform">
                        <div className=" mb-3 titleForm border-bottom">
                            <h4 className="">Holiday</h4>
                        </div>

                        <div className="row card_id">
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="name" className="form-label">Name</label>
                                        <input type="text" className="form-control" id="name" />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="date" className="form-label">Date</label>
                                        <input type="date" className="form-control" id="date" />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="employeeID" className="form-label">Days</label>
                                        <select className="form-select form-control" aria-label="Default select example">
                                            <option selected>Select Days</option>
                                            <option value="1">Monday</option>
                                            <option value="2">Tuesday</option>
                                            <option value="3">Wednesday</option>
                                            <option value="4">Thursday</option>
                                            <option value="5">Friday</option>
                                            <option value="6">Saturday</option>
                                            <option value="7">Sunday</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row card_id">
                            <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                <div className="cardNum">
                                    <div className="mb-3">
                                        <label for="Years" className="form-label">Years</label>
                                        <select className="form-select form-control" aria-label="Default select example">
                                            <option selected>Select Years</option>
                                            <option value="1">2024</option>
                                            <option value="2">2025</option>
                                            <option value="3">2026</option>
                                            <option value="4">2027</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row card_id mt-4 sm-mt-3">
                            <div className=" col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                                <div className="cardNum">
                                    <div className="mb-3 d-flex gap-2">
                                        <button className="btn btn-primary w-50">Submit</button>
                                        <button className="btn btn-outline-secondary w-50">Reset</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ManageHoliday